import $ from 'jquery';
import checkMetamask from './checkMetamask/checkMetamask';
import {
  block,
  unblock,
} from './blocker';

import {
  getToken,
} from './login';


export default async () => {
  if ($('.js-reload-formations').length) {
    // if (!await checkMetamask()) {
    //   return;
    // }

    await (async () => {
      const widgetId = $('.js-reload-formations').parent().data('designWidgetId');
      // const accounts = await web3Client.eth.getAccounts();
      const token = getToken();

      if (widgetId) {
        block();
        $.post(`/ajax/widget/render?cms_design_widget_id=${widgetId}&is_ajax=1`, `token=${token}&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}`, async (data) => {
          $(`.widget[data-design-widget-id="${widgetId}"]`).html(data);
          unblock();
        });
      }
    })();
  }
};
